import Vue from 'vue'
import Vuex from 'vuex'
import myaxios from '../assets/js/request.js'
Vue.use(Vuex)
const state = {
	currentMenu: null,
	tabsList: [{
		routeName: '/home/index',
		columname: '系统首页'
	}]
}
const getters = {}
const mutations = {
	// 选择标签 选择面包屑
	selectMenu (state, val) {
		for (var i = 0; i < state.tabsList.length; i++) {
			if (val.routeName == state.tabsList[i].routeName) {
				return
			}
		}
		if (val.routeName === '/home/index') {
			state.currentMenu = null
		} else {
			state.currentMenu = val
			// 如果等于-1说明tabsList不存在那么插入，否则什么都不做
			let result = state.tabsList.findIndex(item => item.path === val.routeName)
			result === -1 ? state.tabsList.push(val) : ''
		}
		// val.name === 'home' ? (state.currentMenu = null) : (state.currentMenu = val)
	},
	// 关闭标签
	closeTab (state, val) {
		let result = state.tabsList.findIndex(item => item.routeName === val.routeName)
		state.tabsList.splice(result, 1)
	}
}
const actions = {
	getUser (context, id) {
		context.commit('getUserId', id)
	}
}
const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js